export const iconFontAwesomeUsersPeoplePersonMilitaryToPerson = (
	<i className="fa-solid fa-person-military-to-person"></i>
);
